import formatDate from '../helpers/formatDate';
import formatServiceMinutes from '../helpers/formatServiceMinutes';

export default ({ date, time, servicesText, servicesTime }) => `
			<div class="modal-form__info">
				<ul class="modal-form__list">
					<li class="modal-form__item">
					Вы записаны на:
					 <span class="modal__time--green">${formatDate(date)}</span> г. на
					 <span class="modal__time--green">${time}</span></li>
					<li class="modal-form__item">
						Услуга: <span class="modal__time--green">${servicesText}</span>
					</li>
					<li class="modal-form__item">Время: <span class="modal__time--green">${formatServiceMinutes(
						servicesTime
					)}</span></li>
				</ul>
				<br>
				<span>Время ожидания клиента 3 минуты</span>
			</div>
`;
